// src/components/watchDetail/ParticipantSection/ParticipantList.js
import React from "react";
import PropTypes from "prop-types";
import { Clock } from "lucide-react";
import "./ParticipantList.css";
import CryptoIconWrapper from "../../../cryptoicons/CryptoIconWrapper";

const ParticipantList = ({ participants }) => {
  if (!participants?.length) {
    return <div className="participants-empty">No participants yet</div>;
  }

  return (
    <div className="participants-list-container">
      {participants.map((participant) => (
        <div key={participant.address} className="participant-item">
          <div className="participant-info">
            <div className="participant-avatar">
              <img
                src={participant.avatar}
                alt={`Participant ${participant.address}`}
                loading="lazy"
              />
            </div>
            <div className="participant-details">
              <span className="participant-address">{participant.address}</span>
              <div className="participant-joined">
                <Clock size={14} />
                <span>{participant.joinedAgo}</span>
              </div>
            </div>
          </div>
          <div className="participant-bet">
            <div className="bet-token">
              <CryptoIconWrapper name={participant.token.toLowerCase()} size={16} />
              <span className="token-symbol">{participant.token}</span>
            </div>
            <span className="bet-amount">
              ${participant.bet.toLocaleString()}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

ParticipantList.propTypes = {
  participants: PropTypes.arrayOf(
    PropTypes.shape({
      address: PropTypes.string.isRequired,
      avatar: PropTypes.string.isRequired,
      bet: PropTypes.number.isRequired,
      token: PropTypes.string.isRequired,
      joinedAgo: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ParticipantList;
